/**
 * The single QueryClient for the app. Server state is global by nature, so it
 * is created once at module scope and handed to `<QueryClientProvider>` in
 * `App.tsx` (see `docs/state.md` for the server-vs-client split).
 *
 * Defaults are the conservative web-app baseline:
 * - `staleTime` 60s — dashboards tolerate a minute of staleness; the user
 *   won't see a spinner on every tab switch.
 * - `gcTime` 5min — inactive cache is dropped after five minutes.
 * - `retry` 1 — one retry smooths transient blips without hiding real errors.
 * - `refetchOnWindowFocus` off — refetching every alt-tab is noisy for a
 *   finance dashboard; turn it on per query if a view needs freshness.
 */

import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
